// color config
import {
  textTitleMyLearningJourney,
  ColorPrimary,
  textModuleWarning,
  colorTextDesc,
} from "../../../../../../../config/constant/color/index";

const styles = {
  alertMessage: {},
  layoutStyle: {
    backgroundColor: "transparent",
    width: "100%",
    height: "100%",
    position: "relative",
  },
  layoutStyleMobile: {
    backgroundColor: "transparent",
    width: "100%",
    height: "100%",
    position: "relative",
    minHeight: "100vh",
  },
  contentStyle: {
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
  },
  contentStyleMobile: {
    height: "87vh",
    overflowY: "auto",
    overflowX: "hidden",
    flex: "unset",
  },
  contentWrapper: {
    margin: "40px",
  },
  imageThumbnailWrapper: {
    marginBottom: "21px",
  },
  avatarThumbnailSkeleton: {
    width: "200px",
    height: "135px",
    borderRadius: "8px",
  },
  imageThumbnail: {
    borderRadius: "8px",
    objectFit: "cover",
  },
  moduleCountWrapper: {
    fontSize: "12px",
    fontWeight: "400",
    marginBottom: "10px",
  },
  moduleCountWrapperHide: {
    fontSize: "12px",
    fontWeight: "400",
    marginBottom: "10px",
    visibility: "hidden",
  },
  textModuleCountSkeleton: {
    minWidth: "70px",
  },
  moduleNameWrapper: {
    fontSize: "22px",
    fontWeight: "500",
    color: textTitleMyLearningJourney,
    marginBottom: "10px",
  },
  textModuleNameSkeleton: {
    minWidth: "500px",
  },
  moduleSpecWrapper: {
    marginRight: "30px",
  },
  moduleSpecRowOneSkel: {
    display: "flex",
    marginBottom: "6px",
  },
  moduleSpecRowTwoSkel: {
    display: "flex",
  },
  inputSkeletonTop: {
    minWidth: "200px",
    marginRight: "30px",
  },
  inputSkeletonBot: {
    minWidth: "200px",
  },
  tableWidth: {
    width: "100%",
  },
  typeGradeWidth: {
    width: "110px",
  },
  colorToPrimary: {
    color: ColorPrimary,
  },
  colorToPrimaryMobile: {
    color: ColorPrimary,
    fontSize: "14px",
    fontWeight: "400",
  },
  attemptWidth: {
    width: "130px",
  },
  divider: {
    margin: "20px 0",
  },
  moduleDescWrapper: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "1.4",
    textAlign: "left",
    whiteSpace: "pre-wrap",
  },
  moduleDescWrapperMobile: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    whiteSpace: "pre-wrap",
    color: colorTextDesc,
    zIndex: 20,
    marginBottom: "12px",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    right: 0,
    boxShadow: "3px 0 16px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#FFFFFF",
    padding: "20px 40px",
  },
  footerMobile: {
    position: "fixed",
    bottom: "0",
    left: 0,
    width: "100%",
    right: 0,
    backgroundColor: "#FFFFFF",
    padding: "0px 18px 20px 18px",
    paddingBottom: "20px",
    zIndex: 21,
    justifySelf: "center",
    maxWidth: "585px",
    margin: "0 auto",
  },
  alertMessageWrapper: {
    paddingRight: "24px",
  },
  alertMessageWrapperMobile: {
    paddingRight: "0",
    marginBottom: "16px",
  },
  buttonWrapper: {
    margin: "auto",
  },
  buttonStyle: {
    fontWeight: "500",
    maxWidth: "200px",
    height: "40px",
    borderRadius: "6px",
  },
  buttonStyleMobile: {
    fontWeight: "500",
    maxWidth: "100%",
    height: "40px",
    borderRadius: "6px",
    width: "100%",
  },
  tableRowCustom: {
    fontSize: "12px",
    fontWeight: "400",
    color: colorTextDesc,
    paddingBottom: "6px",
    minWidth: "110px",
  },
};

export default styles;
